import { FC, useContext, useEffect, useState } from "react";
import {ConnectionContext} from "../contexts/ConnectionProviderContext";
import TweetsContainer from "../utils/TweetsContainer";
import { Program } from "@project-serum/anchor";
import { TweeterDapp } from "../types/tweeter_dapp";
import { useWallet } from "@solana/wallet-adapter-react";
import MockWallet from "../contexts/MockWallet";
import { LikeContext } from "../contexts/LikesContext";
import setTweetsWithUserLike from "../utils/Tweets";
const Profile: FC = () => {
    const {workSpace}: any = useContext(ConnectionContext);
    const {allLikes, userLikes}: any = useContext(LikeContext);
    const [tweetsByProfile, settweetsByProfile] = useState<any | null>([]);
    const [userPublicKey, setUserPublicKey] = useState("Anonymous, Please connect your wallet.");

    const wallet = workSpace.wallet;
    const program = workSpace.program as Program<TweeterDapp>; 

    const userWallet = useWallet();

    useEffect(() => {
        if(userWallet?.publicKey && MockWallet?.publicKey !== wallet?.publicKey) {
            const publicKey = wallet?.publicKey?.toString();
            const userName = publicKey;
            setUserPublicKey(userName);
        }
    },[wallet, userWallet]);


    useEffect(() => {
        (async () => {
            try {
                const tweets = await program.account.tweet.all([
                    {
                        memcmp: {
                            
                            offset: 8,
                            bytes: wallet?.publicKey.toString()
                        }
                    }
                ]);

                const tweetsWithUserLikes = setTweetsWithUserLike(allLikes,tweets,userLikes);
                settweetsByProfile(tweetsWithUserLikes);
            } catch (error) {
                console.log("Error in Profile", error);
            } 
        })();
    },[wallet])
    return (
        <main className=" pt-5 gap-4 col-start-3 col-span-12 px-2 md:row-start-7 md:col-start-3 md:col-span-7 md:pt-8 md:items-end xl:col-start-5 xl:col-span-4">
  
    <h1 className="text-center font-medium text-lg">Profile Page</h1>
    <h1 className="text-center font-medium text-sm md:text-base pt-4 ">Hi! <span className="text-blue-400 underline underline-offset-2">{userPublicKey}</span></h1> 
    {wallet?.publicKey && tweetsByProfile.length === 0 && <h1 className="text-center text-xl font-extrabold text-blue-400 pt-4">No Posts yet!</h1>}
    <TweetsContainer tweets = {tweetsByProfile}/>
</main>
    )
}

export default Profile;